export const buttonIconAppearance = <const>['inline', 'solid', 'solid-outline', 'transparent', 'transparent-outline'];
export type ButtonIconAppearance = typeof buttonIconAppearance[number];

export const buttonIconPalette = <const>['basic', 'brand', 'inverse'];
export type ButtonIconPalette = typeof buttonIconPalette[number];

export const buttonIconSize = <const>['sm', 'md', 'lg'];
export type ButtonIconSize = typeof buttonIconSize[number];
